import { IActionContext } from '../helpers/ActionContext';
import { L10n } from '../L10n/L10n';
import { FlowContentType } from '../models/ContentTypes';
import { FlowBaseInfo } from '../models/FlowInfo';
import { IErrorItem } from '../models/MultipleItemResult';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { Flows } from '../resources/Flows';
import { IChangeContentTagsAction, IChangeContentTagsResult } from '../ServerApi/types/IChangeContentTagsAction';
import { ChangeTagsActionHelperService } from './ChangeTagsActionHelper';
import { IErrorDetail, INotificationTranslationFns, actionSuccessTranslation, actionErrorTranslation } from './ContentActionNotification';
import { ContentUrlForItem } from './ContentUrl';
import { Messages } from '../../codegen/Localize';

export class ChangeFlowsTagsAction implements IChangeContentTagsAction {

  public static notificationTranslationFns: INotificationTranslationFns = {
    success: actionSuccessTranslation(Messages.changeTagsFlowsSuccess),
    error: actionErrorTranslation(Messages.changeTagsFlowsError),
  };

  public execute: (itemSet: Set<FlowBaseInfo>, actionContext: IActionContext) => ng.IPromise<IChangeContentTagsResult>;

  public static $inject = [
    '$translate',
    'ChangeTagsActionHelperService',
    'Flows'
  ];

  constructor(
    private $translate: ng.translate.ITranslateService,
    private ChangeTagsActionHelper: ChangeTagsActionHelperService,
    private Flows: Flows,
  ) {
    this.execute = ChangeTagsActionHelper.createExecuteFn<FlowBaseInfo>({
      changeTagsAction: (ids: string[], addTags: string[], removeTags: string[]) => this.Flows.changeTags(ids, addTags, removeTags),
      getDescription: (flows: Set<FlowBaseInfo>) => this.getDescription(flows),
      notificationFns: ChangeFlowsTagsAction.notificationTranslationFns,
      errorDetailFn: (errorItem: IErrorItem<FlowBaseInfo>) => this.changeTagsErrorDetail(errorItem)
    });
  }

  private getDescription(flows: Set<FlowBaseInfo>) {
    return (flows.size() === 1)
      ? this.$translate.instant('changeTagsFlowDescription', { NAME: L10n.elideIfLong(flows.first().name) })
      : this.$translate.instant('changeTagsFlowsDescription', { COUNT: flows.size() }, L10n.Interpolations.Count);
  }

  public changeTagsErrorDetail(errorItem: IErrorItem<FlowBaseInfo>): IErrorDetail {
    return {
      itemName: errorItem.item.name,
      itemUrl: ContentUrlForItem(errorItem.item, FlowContentType),
      errorMessage: this.ChangeTagsActionHelper.errorMessageFor(errorItem)
    };
  }

}

Module.instance().service('ChangeFlowsTagsAction', ChangeFlowsTagsAction);
